"use client";

import Image from "next/image";
import { GlareCard } from "../ui/glare-card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import AnimationContainer from "../utils/animation-container";

const data = [
    {
        id: 1,
        title: "قیمت مناسب",
        background_image: "/images/538.jpg",
    },
    {
        id: 2,
        title: "ضمانت محصول",
        background_image: "/images/8542.jpg",
    },
    {
        id: 3,
        title: "بیش از سه سال سابقه",
        background_image: "/images/18587.jpg",
    },
    {
        id: 4,
        title: "تنوع محصولات",
        background_image: "/images/12581.jpg",
    },
    {
        id: 5,
        title: "تحویل سریع",
        background_image: "/images/18443.jpg",
    },
    {
        id: 6,
        title: "پشتیبانی سریع",
        background_image: "/images/18684.png",
    },
];

const FeatureSection = () => {
    return (
        <section className="relative max-w-[1300px] mx-auto flex flex-col gap-14">
            <AnimationContainer delay={0.5}>
                {/* Blurred circles in the background */}
                <div className="absolute -top-20 left-5 md:left-10 w-40 md:w-72 h-40 md:h-72 bg-[#9B4BE4] rounded-full filter blur-2xl md:blur-3xl opacity-30"></div>
                <div className="absolute top-0 right-5 md:right-10 w-48 md:w-96 h-48 md:h-96  bg-purple-500 rounded-full filter blur-[80px] md:blur-[120px] opacity-30"></div>
                <div className="absolute bottom-0 left-5 md:left-10 w-48 md:w-96 h-48 md:h-96 bg-blue-300 rounded-full filter blur-[80px] md:blur-[120px] opacity-30"></div>

                {/* Feature Section Title */}
                <div className="flex flex-col-reverse md:flex-row justify-between items-center lg:items-start md:items-center w-full relative z-10 text-center lg:text-right gap-5">
                    <div className="flex flex-col gap-2 md:gap-4">
                        <p className="text-2xl md:text-4xl font-bold text-white">
                            چرا بازی تور بهترین انتخاب است؟
                        </p>
                        <div className="max-w-md">
                            <p className="text-xs md:text-sm text-white tracking-[-0.015em]">
                                ما بهترین تجربه خرید گیفت کارت، یوسی پابجی، سی‌پی کالاف و
                                ارزهای درون‌برنامه‌ای را با تحویل آنی ارائه می‌دهیم.
                            </p>
                        </div>
                    </div>
                    <div className="bg-gradient-to-r from-purple-500 to-purple-900 w-10 h-10 flex items-center justify-center rounded-2xl">
                        <p lang="en" className="text-3xl">B</p>
                    </div>
                </div>

                {/* Feature Swiper */}
                <div className="flex gap-4 md:gap-8 relative z-50">
                    <Swiper
                        slidesPerView={4}
                        spaceBetween={20}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        navigation={false}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 30,
                            },
                        }}
                        modules={[Autoplay, Navigation]}
                        style={{ padding: "8px" }}
                    >
                        {data.map((item) => (
                            <SwiperSlide key={item.id} className="flex items-center justify-center">
                                <div className="relative flex flex-col items-center justify-center w-full h-full p-4 to-transparent rounded-xl cursor-pointer">



                                    <GlareCard className="rounded-xl z-20 relative opacity-50">
                                        <p className="text-white text-lg font-bold absolute inset-0 flex items-center justify-center z-30">{item.title}</p>
                                        <div className="relative w-full ">
                                            <Image
                                                alt="text box background image"
                                                className="rounded-xl object-cover h-[400px]"
                                                src={item.background_image}
                                                width={1000}
                                                height={1000}
                                            />
                                        </div>
                                    </GlareCard>

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </AnimationContainer>
        </section>
    );
};

export default FeatureSection;
